import {isNull} from "@/utils/formatting";

export default {
    getUserName: state => {
        if (state.currentUser === undefined || state.currentUser === null) {
            return '-';
        }
        return state.currentUser.full_name;
    },
    isAuthenticated: state => {
        return state.currentUser !== null;
    },
    isAdmin: state => {
        return state.currentUser !== null && state.currentUser.is_superuser;
    },
    previousSurgery: (state) => (index) => {
        if (isNull(index)) {
            return state.previousSurgery;
        } else {
            return state.patient.previous_surgeries[index];
        }
    },
    surgery: (state) => (index) => {
        if (isNull(index)) {
            return state.surgery;
        } else {
            return state.patient.surgeries[index];
        }
    },
    postSurgery: (state) => (index) => {
        if (isNull(index)) {
            return state.postSurgery;
        } else {
            return state.surgery.post_surgeries[index];
        }
    },
    finalEvaluation: (state) => {
        if (!isNull(state.surgery)) {
            return state.surgery.final_evaluation;
        }
        return null;
    },
};